<template>
  <v-dialog v-model="dialog" width="600" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable>
    <v-card>
      <v-card-title class="primary white--text "
        ><v-toolbar-title>THÊM KHEN THƯỞNG KỶ LUẬT</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text>
        <violation-new-form ref="form" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer />
        <v-btn depressed color="primary" class="ma-2 white--text" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ViolationNewForm from './ViolationNewForm.vue'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  components: {
    ViolationNewForm
  },
  props: {
    state: Boolean
  },
  data() {
    return {
      dialog: false,
      loading: false
    }
  },
  computed: {
    ...mapState('ClassNoteDetail', ['slot']),
    ...mapGetters('ClassNoteDetail', ['classNoteDetailData'])
  },
  methods: {
    ...mapActions('ClassNoteDetail', ['createViolation']),
    async save() {
      if (!this.$refs.form.validate()) return

      this.$loading.active = true
      const violationData = this.$refs.form.getData()
      try {
        await this.createViolation({
          violationData,
          classNoteDetailData: {
            ...this.classNoteDetailData
          }
        })

        this.$alert.success('Tạo mới thành công')
        this.$refs.form.resetDefault()
        this.dialog = false
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    cancel() {
      this.dialog = false
      this.$refs.form.reset()
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>
